import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: 'AIzaSyDQ_GvK3xJrtOGBsgjnGgz19hT7zFLb1f8',
    authDomain: 'caboose-game.firebaseapp.com',
    projectId: 'caboose-game',
    storageBucket: 'caboose-game.firebasestorage.app',
    messagingSenderId: '565425406176',
    appId: '1:565425406176:web:55f71983d4c24dd1ae9085',
    databaseURL: 'https://caboose-game-default-rtdb.firebaseio.com/'
};

export const ShiritoriFirebaseApp = initializeApp(firebaseConfig);
export const ShiritoriFirebaseDb = getDatabase(ShiritoriFirebaseApp);
export const ShiritoriFirebaseAuth = getAuth(ShiritoriFirebaseApp);
